import { defineStore } from 'pinia'
import { Theme } from '@/types'
import type { Modal } from '@/types'

interface UserBasedState {
  modalsViewed: Modal[]
  termsAccepted: boolean
  bannersViewed: string[]
}

type AppStoreState = {
  theme: Theme
  devMode: boolean
  selectedLanguage: string

  // User settings
  userState: UserBasedState
}

const initialStateFactory = (): AppStoreState => ({
  devMode: false,
  theme: Theme.Dark,
  selectedLanguage: '',

  userState: {
    modalsViewed: [],
    bannersViewed: [],
    termsAccepted: false
  }
})

export const useAppStore = defineStore('app', {
  state: (): AppStoreState => initialStateFactory(),
  actions: {
    setUserState(userState: object) {
      const appStore = useAppStore()

      appStore.$patch({ userState })
    },
    setSelectedLanguage(selectedLocale: string) {
      const appStore = useAppStore()

      appStore.$patch({ selectedLanguage: selectedLocale })
    }
  }
})
